document.addEventListener('DOMContentLoaded', function () {
  /*
   * Hero slider
   */
  const heroSections = document.querySelectorAll('[data-max-hero]');

  heroSections.forEach(function (section) {
    const slides = section.querySelectorAll('[data-max-hero-slide]');
    const dots = section.querySelectorAll('[data-max-hero-dot]');
    const prevButton = section.querySelector('[data-max-hero-prev]');
    const nextButton = section.querySelector('[data-max-hero-next]');

    if (!slides.length) return;

    let currentIndex = 0;

    function showSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides.forEach(function (slide) {
        slide.classList.remove('is-active');
      });

      dots.forEach(function (dot) {
        dot.classList.remove('is-active');
      });

      slides[index].classList.add('is-active');

      if (dots[index]) {
        dots[index].classList.add('is-active');
      }

      currentIndex = index;
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        showSlide(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        showSlide(currentIndex + 1);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        showSlide(index);
      });
    });
  });

  /*
   * Product page interactions
   */
  document.querySelectorAll('[data-max-product]').forEach(function (productSection) {
    const mainImage = productSection.querySelector('[data-max-product-main-image]');
    const thumbs = Array.from(productSection.querySelectorAll('[data-max-product-thumb]'));
    const prevButton = productSection.querySelector('[data-max-product-prev]');
    const nextButton = productSection.querySelector('[data-max-product-next]');
    const zoomButton = productSection.querySelector('[data-max-product-zoom]');
    const lightbox = productSection.querySelector('[data-max-product-lightbox]');
    const lightboxImage = productSection.querySelector('[data-max-product-lightbox-image]');
    const lightboxClose = productSection.querySelector('[data-max-product-lightbox-close]');

    let currentIndex = 0;

    function showImage(index) {
      if (!thumbs.length || !mainImage) return;

      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;

      const thumb = thumbs[index];
      const fullUrl = thumb.dataset.full;

      if (fullUrl) {
        mainImage.src = fullUrl;
        mainImage.srcset = '';
      }

      thumbs.forEach(function (item) {
        item.classList.remove('is-active');
      });

      thumb.classList.add('is-active');
      currentIndex = index;
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        showImage(index);
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        showImage(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        showImage(currentIndex + 1);
      });
    }

    if (zoomButton && lightbox && lightboxImage && mainImage) {
      zoomButton.addEventListener('click', function () {
        const activeThumb = thumbs[currentIndex];
        const zoomUrl = activeThumb ? activeThumb.dataset.zoom : mainImage.src;

        lightboxImage.src = zoomUrl || mainImage.src;
        lightbox.hidden = false;
        document.body.classList.add('max-lightbox-open');
      });
    }

    if (lightboxClose && lightbox) {
      lightboxClose.addEventListener('click', function () {
        lightbox.hidden = true;
        document.body.classList.remove('max-lightbox-open');
      });
    }

    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) {
          lightbox.hidden = true;
          document.body.classList.remove('max-lightbox-open');
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox && !lightbox.hidden) {
        lightbox.hidden = true;
        document.body.classList.remove('max-lightbox-open');
      }
    });

    /*
     * Product tabs
     */
    const tabButtons = Array.from(productSection.querySelectorAll('[data-max-tab]'));
    const tabPanels = Array.from(productSection.querySelectorAll('[data-max-tab-panel]'));

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const target = button.dataset.maxTab;

        tabButtons.forEach(function (item) {
          item.classList.remove('is-active');
        });

        tabPanels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        button.classList.add('is-active');

        const activePanel = productSection.querySelector('[data-max-tab-panel="' + target + '"]');

        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });

    /*
     * Local wishlist
     */
    const wishlistButton = productSection.querySelector('[data-max-wishlist]');

    if (wishlistButton) {
      const handle = wishlistButton.dataset.productHandle;
      const textEl = wishlistButton.querySelector('[data-max-wishlist-text]');
      const iconEl = wishlistButton.querySelector('[data-max-wishlist-icon]');
      const storageKey = 'maxWishlist';

      function getWishlist() {
        try {
          return JSON.parse(localStorage.getItem(storageKey)) || [];
        } catch (error) {
          return [];
        }
      }

      function saveWishlist(items) {
        localStorage.setItem(storageKey, JSON.stringify(items));
      }

      function updateWishlistButton() {
        const wishlist = getWishlist();
        const exists = wishlist.includes(handle);

        wishlistButton.classList.toggle('is-active', exists);

        if (textEl) {
          textEl.textContent = exists
            ? 'Toegevoegd aan verlanglijst'
            : textEl.dataset.defaultText || 'Toevoegen aan verlanglijst';
        }

        if (iconEl) {
          iconEl.textContent = exists ? '♥' : '♡';
        }
      }

      if (textEl && !textEl.dataset.defaultText) {
        textEl.dataset.defaultText = textEl.textContent;
      }

      wishlistButton.addEventListener('click', function () {
        let wishlist = getWishlist();

        if (wishlist.includes(handle)) {
          wishlist = wishlist.filter(function (item) {
            return item !== handle;
          });
        } else {
          wishlist.push(handle);
        }

        saveWishlist(wishlist);
        updateWishlistButton();
      });

      updateWishlistButton();
    }
  });
});